import React from 'react'
import { useBrowserService } from '../../lib/hooks'
import { TypeVariationContainerDeviceType } from '../../lib/types'
import { ContentProps, ContentRenderer } from '../renderer'

export const DeviceTypeVariationContainer: React.FC<ContentProps<TypeVariationContainerDeviceType>> = (props) => {
  const { isMobileOrTablet } = useBrowserService()
  const { mobile: mobileStructure, desktop: desktopStructure } = props.structure?.fields || {}

  if (isMobileOrTablet) {
    return mobileStructure ? <ContentRenderer structure={mobileStructure} /> : null
  }

  return desktopStructure ? <ContentRenderer structure={desktopStructure} /> : null
}
